// Browser mirror of functions/src/lib/price-bounds.ts. Same numbers, same
// meaning; kept as a separate file because the app and the functions build are
// separate TypeScript projects (see money.ts, subscriptions.ts for the same
// split). The server is authoritative — every bound here is re-checked in
// firestore.rules and again at checkout.

/** Lowest price a non-free product may carry, in AUD. */
export const PRICE_MIN_AUD = 1;

/**
 * Highest price a product, tier, PWYW payment, or subscription cycle may carry,
 * in AUD. Sellers enter prices in their own display currency, so compare the
 * AUD-converted value (toUsd(), which despite the name returns AUD) against
 * this, never the raw input.
 */
export const PRICE_MAX_AUD = 10000;

/** True when an AUD amount sits inside the platform's price bounds. */
export function isPriceWithinBounds(aud: number): boolean {
  return Number.isFinite(aud) && aud >= PRICE_MIN_AUD && aud <= PRICE_MAX_AUD;
}
